export default {
  "content": "<g clip-path=\"url(#clip0_794_65131)\"><path d=\"M111.62 63.17v29.49L83.19 64.83l28.43-1.66z\" fill=\"#F6F6F9\"/><path d=\"M41.06 71.41h86.4a6.27 6.27 0 006.27-6.27V5.95a6.27 6.27 0 00-6.27-6.27h-86.4a6.27 6.27 0 00-6.27 6.27v59.19a6.27 6.27 0 006.27 6.27z\" fill=\"#F6F6F9\"/><path d=\"M49.51 14.06h69.52M49.51 24.81h69.52M49.51 35.55h69.52M49.51 46.29h69.52M49.51 57.03h44.21\" stroke=\"#D7D8DF\" stroke-width=\"3.36\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/></g><defs><clipPath id=\"clip0_794_65131\"><path fill=\"#fff\" d=\"M0 0h166v93H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "166",
    "height": "93",
    "viewBox": "0 0 166 93",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};